const findChildren = function (routerName, callback) {
  if (this.name === routerName) {
    callback.call(this, this)
    return true
  }

  if (!this.children) {
    return false
  }

  return this.children.forEach(child => {
    if (child.name === routerName) {
      callback(child)
    } else if (child.children) {
      findChildren.call(child, routerName, callback)
    }
    return true
  })
}

export default {
  LOCATIONS_SET: (state, locations) => {
    state.locations = locations
  },
  UPDATE_COUNT: (state, routerCount) => {
    Object.keys(routerCount).forEach(routerName => {
      const count = routerCount[routerName]
      const updateNavItemCount = route => {
        findChildren.call(route, routerName, child => {
          child.meta = Object.assign({}, child.meta, { count })
        })
      }

      state.routes.forEach(updateNavItemCount)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js